import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import MailIcon from 'assets/images/Dashboard/mail-request.svg';
import CallIcon from 'assets/images/Dashboard/call-request.svg';
import SwitchList from 'components/commom/SwitchList';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import DeleteList from 'assets/images/Dashboard/delete.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getProviderListData } from 'store/providerList/providerListAction';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import { getUpdateStatusValue } from 'store/providerStatus/providerStatusAction';
import { deletePatientData } from 'store/patientListDelete/patientListDeleteAction';
import { doctorDetail } from 'routes/AppUrls';
import { ClearTokenRedirectLogin } from 'utils/general';
import ReusablePagination from 'components/commom/Pagination';
import {
  basicDetailsValue,
  PROVIDER_ID,
} from 'store/BasicDetailaAllValue/BasicDetailsValueAction';
import { getDoctorDrop } from 'store/getDoctorListDropdown/getDoctorListDropdownAction';
import CommonToast from 'components/commom/CommonToast';
import ReusableButton from 'components/commom/Button';
import CommonModal from 'components/commom/Modal';
import CheckPromote from 'assets/images/Dashboard/check.svg';
import CrossIcon from 'assets/images/Dashboard/cross.svg';
import { Tooltip } from '@mui/material';

const DoctorList = () => {
  const { locale } = useContext(LocaleContext);
  const intl = useIntl();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [providerList, setProviderList] = useState([]);
  const [selectDropCountry, setSelectDropCountry] = useState([]);
  const [selectDropState, setSelectDropState] = useState([]);
  const [selectDropCity, setSelectDropCity] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [formData, setFormData] = useState({
    countryValue: '',
    countryId: '',
    stateValue: '',
    stateId: '',
    cityValue: '',
    cityId: '',
    title: '',
    titleId: '',
  });
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const itemsPerPage = 10;

  const loading = useSelector((state) => state?.providerListReducer?.loading);

  const doctorTitle = useSelector(
    (state) => state?.getMasterDataReducer?.users?.data
  );

  const deleteLoading = useSelector(
    (state) => state?.deletepatientListReducer?.loading
  );

  useEffect(() => {
    getProviderList();
    dropDownValues();
  }, []);

  const getProviderList = (
    pageValue,
    countryName,
    stateName,
    cityName,
    titleName
  ) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProviderList(res?.data);
        setCount(Math.ceil(res?.count / itemsPerPage));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(
      getProviderListData(
        external,
        pageValue,
        countryName,
        stateName,
        cityName,
        titleName
      )
    );
  };

  const dropDownValues = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setSelectDropCountry(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getDoctorDrop(external));
  };

  const handleInputChange = (event) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        if (name === 'countryValue') {
          setSelectDropState(res?.data);
        } else if (name === 'stateValue') {
          setSelectDropCity(res?.data);
        }
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    const { name, value } = event?.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value?.name,
      ...(name === 'countryValue' && {
        countryId: value?.id,
        stateValue: '',
        stateId: '',
        cityValue: '',
        cityId: '',
        titleId: '',
        title: '',
      }),
      ...(name === 'stateValue' && {
        stateId: value?.id,
        cityValue: '',
        cityId: '',
      }),
      ...(name === 'cityValue' && { cityId: value?.id }),
      ...(name === 'title' && { titleId: value?.id }),
    }));

    const getProviderListWithParams = (countryId, stateId, cityId, titleId) => {
      getProviderList(
        undefined,
        countryId || undefined,
        stateId || undefined,
        cityId || undefined,
        titleId
      );
    };

    if (name === 'title') {
      const { countryId, stateId, cityId } = formData || {};

      getProviderListWithParams(
        countryId || '',
        stateId || '',
        cityId || '',
        value?.id
      );
    } else if (name === 'countryValue') {
      dispatch(getDoctorDrop(external, value?.id));
      getProviderListWithParams(value?.id);
    } else if (name === 'stateValue') {
      dispatch(getDoctorDrop(external, formData?.countryId, value?.id));
      getProviderListWithParams(formData?.countryId, value?.id);
    } else if (name === 'cityValue') {
      getProviderListWithParams(
        formData?.countryId,
        formData?.stateId,
        value?.id
      );
    }
  };

  const practiceNames = (item) => {
    return [
      item?.practice_area?.[0]?.practice_name,
      item?.practice_area?.[1]?.practice_name,
    ]
      .filter(Boolean)
      .join(',');
  };

  const handleChange = (id) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        getProviderList();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {};
    dispatch(getUpdateStatusValue(external, id, body));
  };

  const handleDoctorDetail = (id) => {
    navigate(doctorDetail(locale));
    dispatch(basicDetailsValue(PROVIDER_ID, id));
  };

  const handleDeleteModal = (id) => {
    setDeleteModal(true);
    setDeleteId(id);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setDeleteId('');
  };

  const deleteProviderList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseDeleteModal();
        getProviderList();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(deletePatientData(external, deleteId));
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    getProviderList(value);
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0 pb-20">
            <FormattedMessage id="Providers" />
          </h2>
          {loading ? (
            <Loader />
          ) : (formData?.countryValue === '' ||
              formData?.stateValue === '' ||
              formData?.cityValue === '' ||
              formData?.title === '') &&
            providerList &&
            providerList?.length > 0 ? (
            <>
              <Row className="m-0 p-0 ">
                <Col md={8} className="m-0 p-0 ">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center p-0"
                  >
                    <div className="fc-292D32 lh-201 family_outfit_medium_500">
                      Sort by:
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'Country',
                        })}
                        name={'countryValue'}
                        value={formData?.countryValue}
                        data={selectDropCountry}
                        onChange={(e) => handleInputChange(e, 'countryValue')}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'State',
                        })}
                        name={'stateValue'}
                        value={formData?.stateValue}
                        data={selectDropState}
                        onChange={(e) => handleInputChange(e, 'stateValue')}
                        disabled={!formData?.countryValue?.length}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'City',
                        })}
                        name={'cityValue'}
                        value={formData?.cityValue}
                        data={selectDropCity}
                        onChange={(e) => handleInputChange(e, 'cityValue')}
                        disabled={!formData?.stateValue?.length}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'Title',
                        })}
                        name={'title'}
                        value={formData?.title}
                        data={doctorTitle?.[0]?.values}
                        onChange={(e) => handleInputChange(e, 'title')}
                        background={'#FFFFFF'}
                        width={'276px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                  </Stack>
                </Col>
              </Row>
              <div className="pt-20">
                <Row className="listCustomHeader m-0 p-0 flex items-center">
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Patient & ID" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Contact Info" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="City" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="State" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Practice" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Status" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Internal Doctor" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Subscription Status" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Medical Status" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Actions" />
                    </p>
                  </Col>
                </Row>
                <Row className="m-0 p-0">
                  {providerList.map((item, index) => {
                    return (
                      <Row className="m-0 p-0 flex items-center listAppointment">
                        <Col
                          lg={2}
                          md={6}
                          sm={12}
                          className="cursor-pointer"
                          onClick={() => handleDoctorDetail(item?.id)}
                        >
                          <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                            {item?.provider_name}
                          </div>
                          <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                            {item?.provider_id}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          {/* <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center "
                          >
                            <img src={MailIcon} alt="icon" />
                            <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                              {item?.provider_email}
                            </div>
                          </Stack> */}
                          {/* <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center pt-04"
                          >
                            <img src={CallIcon} alt="icon" />
                            <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                              {item?.provider_country_code}{' '}
                              {item?.provider_phone}
                            </div>
                          </Stack> */}
                          <div className="flex items-center gap-[10px]">
                            {item?.provider_email && (
                              <Tooltip title={item?.provider_email} arrow>
                                <Image
                                  src={MailIcon}
                                  alt="icon"
                                  style={{ cursor: 'pointer' }}
                                />
                              </Tooltip>
                            )}
                            {item?.provider_phone && (
                              <Tooltip
                                title={
                                  item?.provider_country_code +
                                  item?.provider_phone
                                }
                                arrow
                              >
                                <Image
                                  src={CallIcon}
                                  alt="icon"
                                  style={{ cursor: 'pointer' }}
                                />
                              </Tooltip>
                            )}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                            {item?.provider_city}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                            {item?.provider_state}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                            {practiceNames(item)}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <SwitchList
                            checked={item?.is_active}
                            onChange={(event) => handleChange(item?.id)}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        </Col>
                        <Col
                          lg={1}
                          md={6}
                          sm={12}
                          className="flex justify-center"
                        >
                          {item?.is_internal === true ? (
                            <Image src={CheckPromote} alt="icon" />
                          ) : (
                            <Image src={CrossIcon} alt="icon" />
                          )}
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          {item?.is_subscribed === true ? (
                            <Image src={CheckPromote} alt="icon" />
                          ) : (
                            <Image src={CrossIcon} alt="icon" />
                          )}
                        </Col>
                        <Col
                          lg={1}
                          md={6}
                          sm={12}
                          className="flex justify-center"
                        >
                          {item?.active_status === true ? (
                            <Image src={CheckPromote} alt="icon" />
                          ) : (
                            <Image src={CrossIcon} alt="icon" />
                          )}
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <Stack
                            direction="horizontal"
                            gap={1}
                            className="items-center cursor-pointer"
                          >
                            {/* <div
                              className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                              onClick={() => handleDoctorDetail(item?.id)}
                            >
                              <FormattedMessage id="View Details" />
                            </div> */}
                            {/* <img
                              src={ArrowRightIcon}
                              alt="icon"
                              onClick={() => handleDoctorDetail(item?.id)}
                            /> */}
                            <div className="">
                              {/*pl-28*/}
                              <Image
                                src={DeleteList}
                                alt="icon"
                                onClick={() => handleDeleteModal(item?.id)}
                              />
                            </div>
                          </Stack>
                        </Col>
                      </Row>
                    );
                  })}
                </Row>
              </div>
            </>
          ) : (formData?.countryValue !== '' ||
              formData?.stateValue !== '' ||
              formData?.cityValue !== '' ||
              formData?.title !== '') &&
            providerList &&
            providerList?.length > 0 ? (
            <>
              <Row className="m-0 p-0 ">
                <Col md={8} className="m-0 p-0 ">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center p-0"
                  >
                    <div className="fc-292D32 lh-201 family_outfit_medium_500">
                      Sort by:
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'Country',
                        })}
                        name={'countryValue'}
                        value={formData?.countryValue}
                        data={selectDropCountry}
                        onChange={(e) => handleInputChange(e, 'countryValue')}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'State',
                        })}
                        name={'stateValue'}
                        value={formData?.stateValue}
                        data={selectDropState}
                        onChange={(e) => handleInputChange(e, 'stateValue')}
                        disabled={!formData?.countryValue?.length}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'City',
                        })}
                        name={'cityValue'}
                        value={formData?.cityValue}
                        data={selectDropCity}
                        onChange={(e) => handleInputChange(e, 'cityValue')}
                        disabled={!formData?.stateValue?.length}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'Title',
                        })}
                        name={'title'}
                        value={formData?.title}
                        data={doctorTitle?.[0]?.values}
                        onChange={(e) => handleInputChange(e, 'title')}
                        background={'#FFFFFF'}
                        width={'276px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                  </Stack>
                </Col>
              </Row>
              <div className="pt-20">
                <Row className="listCustomHeader m-0 p-0 flex items-center">
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Patient & ID" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="City" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="State" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Practice" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Contact Info" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Status" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Medical Status" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Actions" />
                    </p>
                  </Col>
                </Row>
                <Row className="m-0 p-0">
                  {providerList.map((item, index) => {
                    return (
                      <Row className="m-0 p-0 flex items-center listAppointment">
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                            {item?.provider_name}
                          </div>
                          <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                            {item?.provider_id}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                            {item?.provider_city}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                            {item?.provider_state}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <div className="fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center break-all ...">
                            {practiceNames(item)}
                          </div>
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center "
                          >
                            <img src={MailIcon} alt="icon" />
                            <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                              {item?.provider_email}
                            </div>
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center pt-04"
                          >
                            <img src={CallIcon} alt="icon" />
                            <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                              {item?.provider_country_code}{' '}
                              {item?.provider_phone}
                            </div>
                          </Stack>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <SwitchList
                            checked={item?.is_active}
                            onChange={(event) => handleChange(item?.id)}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        </Col>
                        <Col
                          lg={1}
                          md={6}
                          sm={12}
                          className="flex justify-center"
                        >
                          {item?.active_status === true ? (
                            <Image src={CheckPromote} alt="icon" />
                          ) : (
                            <Image src={CrossIcon} alt="icon" />
                          )}
                        </Col>
                        <Col lg={2} md={6} sm={12}>
                          <Stack
                            direction="horizontal"
                            gap={1}
                            className="items-center cursor-pointer"
                          >
                            <div
                              className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                              onClick={() => handleDoctorDetail(item?.id)}
                            >
                              <FormattedMessage id="View Details" />
                            </div>
                            <img
                              src={ArrowRightIcon}
                              alt="icon"
                              onClick={() => handleDoctorDetail(item?.id)}
                            />
                            <div className="pl-28">
                              <Image
                                src={DeleteList}
                                alt="icon"
                                onClick={() => handleDeleteModal(item?.id)}
                              />
                            </div>
                          </Stack>
                        </Col>
                      </Row>
                    );
                  })}
                </Row>
              </div>
            </>
          ) : (formData?.countryValue !== '' ||
              formData?.stateValue !== '' ||
              formData?.cityValue !== '' ||
              formData?.title !== '') &&
            providerList &&
            providerList?.length === 0 ? (
            <>
              <Row className="m-0 p-0 ">
                <Col md={8} className="m-0 p-0 ">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center p-0"
                  >
                    <div className="fc-292D32 lh-201 family_outfit_medium_500">
                      Sort by:
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'Country',
                        })}
                        name={'countryValue'}
                        value={formData?.countryValue}
                        data={selectDropCountry}
                        onChange={(e) => handleInputChange(e, 'countryValue')}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'State',
                        })}
                        name={'stateValue'}
                        value={formData?.stateValue}
                        data={selectDropState}
                        onChange={(e) => handleInputChange(e, 'stateValue')}
                        disabled={!formData?.countryValue?.length}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'City',
                        })}
                        name={'cityValue'}
                        value={formData?.cityValue}
                        data={selectDropCity}
                        onChange={(e) => handleInputChange(e, 'cityValue')}
                        disabled={!formData?.stateValue?.length}
                        background={'#FFFFFF'}
                        width={'207px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                    <div>
                      <SelectInputBorder
                        placeholder={intl.formatMessage({
                          id: 'Title',
                        })}
                        name={'title'}
                        value={formData?.title}
                        data={doctorTitle?.[0]?.values}
                        onChange={(e) => handleInputChange(e, 'title')}
                        background={'#FFFFFF'}
                        width={'276px'}
                        colorIcon={'#292D32'}
                        placeholderColor={'#292D32'}
                      />
                    </div>
                  </Stack>
                </Col>
              </Row>
              <div className="pt-20">
                <Row className="listCustomHeader m-0 p-0 flex items-center">
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Patient & ID" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="City" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="State" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Practice" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Contact Info" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Status" />
                    </p>
                  </Col>
                  <Col lg={1} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Medical Status" />
                    </p>
                  </Col>
                  <Col lg={2} md={6} sm={12}>
                    <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                      <FormattedMessage id="Actions" />
                    </p>
                  </Col>
                </Row>
              </div>
              <div className="flex justify-center pt-120">
                <div>
                  <Image src={EmptyScreen} alt="icon" />
                  <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                    Nothing here yet
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="flex justify-center pt-120">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                  Nothing here yet
                </div>
              </div>
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
        </Col>
      </Row>

      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={deleteModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseDeleteModal()}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !deleteLoading && deleteProviderList();
                    }}
                    loading={deleteLoading}
                  >
                    <FormattedMessage id="Delete" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default DoctorList;
